// extracted by mini-css-extract-plugin
module.exports = {"player":"styles_player__2jBiz","controls":"styles_controls__YVUl_","progress":"styles_progress__2OOwC"};